import React from 'react';
import {TFunction} from 'i18next';
import clsx from 'clsx';


interface MethodForPaymentProps {
  className?: string
  translator: TFunction
  methodKey: string //type for payment method
  alternativeMethodKey: any
}


const MethodForPayment = ({className, translator, methodKey, alternativeMethodKey}: MethodForPaymentProps) => {

  return (
    <span className={clsx('is-uppercase', className)}>
      {translator(methodKey || alternativeMethodKey)}
    </span>
  );
};

export default MethodForPayment;
